import { fireUrl } from "api/flights/monetization"
import { loaderFccImage } from "components/Itinerary/AxisLoyality/constants"
import React, { useEffect, useRef, useState } from "react"
const Image = ({ fkResponseImages, innerMargin = 0, outterMargin = 0,  isCarousal =false}) => {
    const [imgSrc, setImgSrc] = useState(loaderFccImage)
const [load,setOnLoad] = useState(false)
const imageRef = useRef(null)
    useEffect(() => {
        let timer;
        const observer = new window.IntersectionObserver(
            entries => {
                entries?.forEach(entry => {
                    if (entry?.isIntersecting) {
                        timer = setTimeout(() => {
                             onViewFireViewEvent()
                            //  observer.unobserve(entry?.target)
                        }, 1000)
                    } else {
                        clearTimeout(timer)
                    }
                })
            },
            { threshold: 0.5 }
        )

        if (imageRef?.current !== null) observer.observe(imageRef.current)
        return () => {
            observer.disconnect()
        }
    }, [])
    
    const onLoadFireImpressionEvent = async (imageArray) => {
        try {
            setOnLoad(true)
            if (imgSrc !== loaderFccImage) {
                const url = fkResponseImages[imageArray]?.adm?.impUrls[0]
                 await fireUrl(url)
            }
        } catch (ex) {
            console.error(ex)
        }
    }

    const onClickFireClickEvent = async (imageArray) => {
        try {
            const urlResp = fkResponseImages && fkResponseImages[imageArray] && fkResponseImages[imageArray]?.adm?.clickUrls[0]?.replace('[EVENTTIME]', Math.floor(Date.now() / 1000))
            const response = await fireUrl(urlResp)
            if (fkResponseImages && fkResponseImages[imageArray] && fkResponseImages[imageArray]?.adm?.assets[0]?.native?.value) {
                const clickUrl = fkResponseImages[imageArray]?.adm?.assets[0]?.native?.value
                    window.location.href = clickUrl
            }
        } catch (ex) {
            console.log(ex)
        }
    }
    useEffect(()=>{
        const imagesList = Array.from(document.querySelectorAll('.lazy-imageFcc '));
        if ('IntersectionObserver' in window) {
            const imageObserver = new IntersectionObserver((entries, observer) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const image = entry.target;
                        image.src = image.dataset.src;
                        setImgSrc(image.src)//logic of not firing multiple impression urls during change of src and data-src
                        // imageObserver.unobserve(image);
                    }
                });
            });
            imagesList.forEach(img => imageObserver.observe(img))
        }
    },[load])
    
    const onViewFireViewEvent = async () => {
                try {
                    Object.keys(fkResponseImages).map(async(imageArray,idx)=>{
                        const url = fkResponseImages[imageArray]?.adm?.viewUrls[0]?.replace('[STARTTIME]', Math.floor(Date.now() / 1000))?.replace('[ENDTIME]', Math.floor(Date.now() / 1000))
                        const response = await fireUrl(url) 
                    })
                } catch (ex) {
                    console.error(ex)
                }
    }
    const numberOfImgs = Object.keys(fkResponseImages).length
     const imgWidth = ((1.0 / numberOfImgs) * 100).toString() + '%'
    const FlipkartImages= Object.keys(fkResponseImages).map((imageArray,idx)=>{

      return (
        <div
        style={{
            width: imgWidth,
            marginRight: idx < numberOfImgs - 1 && innerMargin
        }}
        key={idx}
        ref={imageRef}
        >
              <img
                        className="lazy-imageFcc"
                        data-src={fkResponseImages[imageArray]?.adm?.assets[0]?.img?.url || ''}
                        alt="img"                            
                         src={loaderFccImage}
                         onLoad={()=> onLoadFireImpressionEvent(imageArray)}
                         onClick={() => onClickFireClickEvent(imageArray)}
                        width="100%"
                        style={{ objectFit: 'cover', height: 'auto' }}
                        loading="lazy"
                    />
        </div>
      )
    })
    return (
        <>
        <div style={{ display: 'flex', margin: outterMargin }}> {FlipkartImages}</div>
       
        </>
    )
}

const FkImages = ({ fkResponseImages, isCarousal = false }) => {
    const renderFccAds = () => {
        let component = ''
            component = (
                <div>
                    <Image fkResponseImages={fkResponseImages}/>
                </div>
            )
        return component
    }

    return (<>{renderFccAds()}</>)

}
export default FkImages;
